import React from 'react'
import s from './CommentPaginator.module.scss'
import { ChevronLeft, ChevronRight } from 'react-feather'

type CommentPaginatorProps = {
    currentPage: number
    setCurrentPage: any
    totalPages: number
}

const CommentPaginator: React.FC<CommentPaginatorProps> = ({
    currentPage,
    setCurrentPage,
    totalPages
}) => {
    const handlePrevPageClick = () =>
        setCurrentPage((prevPage: number) => Math.max(prevPage - 1, 1))
    const handleNextPageClick = () =>
        setCurrentPage((prevPage: number) => Math.min(prevPage + 1, totalPages))
    const handlePageClick = (page: number) => setCurrentPage(page)

    const getPageButtons = () => {
        const pageButtons = []
        for (let i = 1; i <= totalPages; i++) {
            pageButtons.push(
                <button
                    key={i}
                    onClick={() => handlePageClick(i)}
                    disabled={currentPage === i}
                    className={
                        s[
                            `${
                                currentPage === i
                                    ? 'comment-current'
                                    : 'comment-page'
                            }`
                        ]
                    }
                >
                    {i}
                </button>
            )
        }
        return pageButtons
    }

    return (
        <div className={s['comment-paginator']}>
            <button
                className={s['comment-arrow']}
                onClick={handlePrevPageClick}
                disabled={currentPage === 1}
            >
                <ChevronLeft width={18} height={18} />
            </button>
            {getPageButtons()}
            <button
                className={s['comment-arrow']}
                onClick={handleNextPageClick}
                disabled={currentPage === totalPages}
            >
                <ChevronRight width={18} height={18} />
            </button>
        </div>
    )
}

export default CommentPaginator
